
<template>
  <section class="content">
    <div class="row">
      <!-- <div class="col-md-3">
          <MenuMailbox />
      </div>-->
      <!-- /.col -->
      <!-- <div class="col-md-9"> -->
      <Compose @hideCompose="handleHideCompose" />
      <!-- </div>     -->
    </div>
    <!-- /.row -->
  </section>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
// import MenuMailbox from './MenuMailbox'
import Compose from "./Compose";
// import i18n from "../../lang";
// import utils from '@/lib/utils';

export default {
  name: "ManagementCompose",
  data() {
    return {};
  },
  watch: {},
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "PAGINATION",
      "PAGINATOR",
      "PAGE_ARROW"])
  },

  methods: {
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST"
    ]),
    handleHideCompose() {
      this.$emit("hideCompose", false);
    }
  },
  mounted() {},

  components: {
    // MenuMailbox,
    Compose
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Mailbox/ManagementCompose.vue